import { DateTime } from "luxon";
import { Column, Row } from "react-table";

export function getCSVData(tableName: 'financial' | 'monthly' | 'accredited', columns : Column[], dataFiltered : Row<object>[]) : any[][] {
  switch (tableName) {
    case 'accredited':
      return [
        columns.filter(column => column.Header !== 'Ações').map(column => column.Header),
        ...dataFiltered.map((objeto) => {
          const data : any = objeto.original
          return [
            data.name,
            data.monthly_id ? data.monthly.name : '',
            data.phone,
            data.vehicle_license_plate,
          ]
        }),
      ]

    case 'financial':
      return [
        columns.map(column => column.Header),
        ...dataFiltered.map((objeto) => {
          const data : any = objeto.original
          return [
            DateTime.fromISO(data.end_hours).toFormat('dd/MM/yyyy'),
            data.name,
            `${DateTime.fromISO(data.start_hours).toFormat('hh:mm')} - ${DateTime.fromISO(data.end_hours).toFormat('hh:mm')}`,
            data.vehicle_type,
            data.courtyard_parking_services.toString(),
            data.type_payment,
            data.status,
          ]
        }),
      ]

    case 'monthly':
      return [
        columns.filter(column => column.Header !== 'Ações').map(column => column.Header),
        ...dataFiltered.map((objeto) => {
          const data : any = objeto.original
          return [
            data.name,
            data.cpf_cnpj,
            data.email,
            data.phone,
            data.vehicle_license_plate ? data.vehicle_license_plate : '',
            data.value,
          ]
        }),
      ]
  
    default:
      return [[null]]
  }
}